const VERIFAST_ACCESS_TOKEN_KEY = 'verifast_access_token';

class SessionStorageController {
  public setToken = (token: string) => {
    sessionStorage.setItem(VERIFAST_ACCESS_TOKEN_KEY, token);
  };

  public getToken = () => {
    return this._getCache(VERIFAST_ACCESS_TOKEN_KEY);
  };

  public clearAll = () => {
    sessionStorage.clear();
  };

  private _getCache = (key: string) => {
    const item = sessionStorage.getItem(key);

    try {
      return JSON.parse(item as string);
    } catch (e) {
      return item;
    }
  };
}

const sessionStorageController = new SessionStorageController();

export { sessionStorageController };
